import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionList, DescriptionListItem, SimpleCardHeading} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";

type Props = {
    order: PlacedOrderOverview,
};

const CustomerCard = ({order}: Props) => {
    const intl = useIntl();
    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading
                        title={<FormattedMessage id={"customer-details"}/>}
                    />
                </CardHeader>
            }
        >
            <DescriptionList compact={true}>
                <DescriptionListItem
                    title={intl.formatMessage({id: "name"})}
                    content={`${order.firstName} ${order.lastName}`}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "email-address"})}
                    content={order.emailAddress ?? "-"}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "phone"})}
                    content={order.phoneNumber ?? "-"}
                />

                {
                    order.businessDetails !== null &&
                    <>
                        <DescriptionListItem
                            title={intl.formatMessage({id: "organisationName"})}
                            content={order.businessDetails.organisationName}
                        />
                        <DescriptionListItem
                            title={intl.formatMessage({id: "cocNumber"})}
                            content={order.businessDetails.cocNumber || "-"}
                        />
                        <DescriptionListItem
                            title={intl.formatMessage({id: "vatNumber"})}
                            content={order.businessDetails.taxNumber || "-"}
                        />
                    </>
                }

                <DescriptionListItem
                    title={intl.formatMessage({id: "account"})}
                    content={
                        order.user === null
                            ? intl.formatMessage({id: "placedWithoutAccount"})
                            : (
                                <p data-user-id={order.user.id}>
                                    <FormattedMessage id={"placedWithAccount"}/>
                                </p>
                            )
                    }
                />
            </DescriptionList>
        </Card>
    );
};

export default CustomerCard;